import { render } from "./bell.svg?vue&type=template&id=305cedfe"
const script = {}
script.render = render

export default script